import * as api from '../../api/api-atender-solicitud';
import { 
    GET_CONFIG_FORM29,
    GET_DATOS_SOLICITUD,
    GET_COMBO_APROBACION,
    POST_PROCESAR_ATENDER
   
} from '../types';

export const configuracionFormAction29 = (query) => ({
    type: GET_CONFIG_FORM29,
    payload: api.getConfiguracionForm29(query)
});
export const obtenerDatosSolicitudDescuento = (query) => ({
    type: GET_DATOS_SOLICITUD,
    payload: api.obtenerDatosSolicitud(query)
});
export const obtenerComboAprobacion = (query) => ({
    type: GET_COMBO_APROBACION,
    payload: api.getComboAprobacion(query)
});
export const postProcesarAtender = (data) => ({
    type: POST_PROCESAR_ATENDER,
    payload: api.postProcesar(data)
});

